import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { controlsWrapper, freeTrialWrapper, wrapper } from './PriceForm.css';
import { PriceInfo } from './PriceInfo';
import { PriceInput } from './PriceInput';
import { FreeTrial } from './FreeTrial';
import { PriceProps } from './Price';

export const PriceForm = ({
  control,
  transformPrice,
  price,
  dispatch,
}: Pick<PriceProps, 'control' | 'transformPrice' | 'price' | 'dispatch'>) => {
  return (
    <div className={wrapper}>
      <div className={controlsWrapper}>
        <PriceInput
          control={control}
          transformPrice={transformPrice}
          price={price}
        />
        <div className={freeTrialWrapper}>
          <Typography
            variant="body"
            size="large"
            className={sprinkles({ paddingLeft: 'm', width: 'max-content' })}
          >
            7-day free trials:
          </Typography>
          <FreeTrial control={control} price={price} />
        </div>
      </div>
      <PriceInfo dispatch={dispatch} />
    </div>
  );
};
